import { render, staticRenderFns } from "./OuterLink.vue?vue&type=template&id=1281fc8d&"
import script from "./OuterLink.js?vue&type=script&lang=js&"
export * from "./OuterLink.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports